import { render, staticRenderFns } from "./IndemnityModalStep3.vue?vue&type=template&id=5a8f26e4&scoped=true"
import script from "./IndemnityModalStep3.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStep3.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStep3.vue?vue&type=style&index=0&id=5a8f26e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f26e4",
  null
  
)

export default component.exports